import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatInput, MatSidenav } from "@angular/material";
import { Router } from '@angular/router';

import { AuthService } from "./auth/auth.service";
import { PerspectiveService } from "./perspective/perspective.service";
import { ThemeService } from "./core/theme.service";

import { ChangePasswordDialogComponent } from "./auth/change-password-dialog/change-password-dialog.component";

import { appVersion } from "./app-version";

import "../faw-styles.css"; //App-wide styles

@Component({
    selector: "faw-app",
    template: require('./app.component.html'),
    styles: [require('./app.component.css')]
})

export class AppComponent implements OnInit {
    @ViewChild(MatInput) public searchInput: MatInput;
    @ViewChild("sidenav") public sidenav: MatSidenav;

    appVersion: string = appVersion.Version;
    releaseDate: string = appVersion.ReleaseDate;
    showSearch: boolean;

    constructor(
        private authService: AuthService,
        private dialog: MatDialog,
        private perspectiveService: PerspectiveService,
        private router: Router,
        private themeService: ThemeService) { }

    ngOnInit() {

    }

    toggleSearchInput() {
        this.showSearch = !this.showSearch;
        if (this.showSearch) {
            // probably shouldnt need this setTimeout?
            // https://github.com/angular/material2/issues/1474#issuecomment-293683513
            setTimeout(() => {
                this.searchInput.focus();
            });
        }
    }

    onSubmit(searchValue: string) {
        this.router.navigate(["/enquiries", { "search": searchValue }]);
        this.searchInput.value = "";
        this.toggleSearchInput();
    }

    goTo(route: string) {
        this.sidenav.close();

        // force internal staff to set perspective before navigating
        if (this.showInternalStaffTools() && !this.perspectiveService.activeIntroducer) {
            this.router.navigate(["/perspective"]);
        } else {
            this.router.navigate([route]);
        }
    }

    logout() {
        this.sidenav.close();
        this.authService.logout();
        this.router.navigate(["/login"]);
    }

    openChangePasswordDialog(): void {
        this.sidenav.close();
        let dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
            disableClose: true,
            data: {
                passwordChangeMandatory: false
            }
        });
    }

    perspectiveNotSet(): boolean {
        return this.authService
            && this.authService.userHasInternalStaffPermission
            && this.perspectiveService
            && !this.perspectiveService.activeIntroducer;
    }

    showInternalStaffTools(): boolean {
        return this.authService && this.authService.userHasInternalStaffPermission;
    }

    showWebAdminTools(): boolean {
        return this.authService && this.authService.userHasWebAdminPermission;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/app.component.ts